import React from "react";
import { Switch } from "react-router-dom";
import { DEVICE_TYPE_MASTER_ROUTE } from "config/route-consts";
import { DEVICE_TYPE_DETAIL_ROUTE } from "config/route-consts";
import { ProtectedRoute, useCheckAuthorized } from "config/protected-route";
import "./DeviceTypeView.scss";
import DeviceTypeMaster from "./DeviceTypeMaster/DeviceTypeMaster";
import DeviceTypeDetail from "./DeviceTypeDetail/DeviceTypeDetail";
function DeviceTypeView() {
  const { auth } = useCheckAuthorized();
  return (
    <Switch>
      <ProtectedRoute
        path={DEVICE_TYPE_MASTER_ROUTE}
        key={DEVICE_TYPE_MASTER_ROUTE}
        component={DeviceTypeMaster}
        auth={auth(DEVICE_TYPE_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={DEVICE_TYPE_DETAIL_ROUTE}
        key={DEVICE_TYPE_DETAIL_ROUTE}
        component={DeviceTypeDetail}
        auth={auth(DEVICE_TYPE_DETAIL_ROUTE)}
      />
    </Switch>
  );
}
export { DeviceTypeMaster };
export default DeviceTypeView;
